import { IFormField } from '@vivli/shared/infrastructure/interface';
import { CSSProperties } from 'react';
import { CheckboxFormFieldComponent } from '@vivli/shared/components';

const publishCheckboxStyle: CSSProperties = {
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingLeft: 0,
    paddingRight: 10,
    display: 'grid',
    gridAutoFlow: 'row',
    paddingBottom: 5,
    paddingTop: 0,
    alignSelf: 'start',
};

interface PublishCheckboxComponentProps extends IFormField {
    name: string;
}

export const PublishCheckboxComponent = ({ name }: PublishCheckboxComponentProps) => {
    return (
        <div style={publishCheckboxStyle}>
            <CheckboxFormFieldComponent name={name} label={''} reverseOrientation={true} truncateLabel={false} />
        </div>
    );
};
